// extracted by mini-css-extract-plugin
export default {"Active":"AutoFollow_Active__rIwTf","Item":"AutoFollow_Item__PaIx8","Property":"AutoFollow_Property__Gnuiw"};